import { SelectedOption } from '../../gzEnumList/types';

export enum EventTypes {
  CHANGE_SELECTED = 'changeSelectedItems',
}

export interface SelectedListItem extends SelectedOption {
  label: string;
  value: number | string;
}

export interface SelectedListGeneratorStrings {
  sectionLeftTitle: string;
  sectionRightTitle: string;
  searchPlaceholderString: string;
  noSearchResultsString: string;
  allLabel: string;
  emptyStateText: string;
}
